<template>
  <div id='transactionIcon'>
    <div class="title-icon text-center">
      <div class="fontsize26">
        <slot name="icon"></slot>
      </div>
      <div class="fontsize24 green">
        <slot name="main"></slot>
      </div>
      <div class="red">
        <slot name="note"></slot>
      </div>
    </div> 
  </div>
</template>

<script>
export default {
  name: "transactionIcon",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.title-icon {
  width: 90%;
  border-radius: 5px;
  border: 1px solid #e4e4e4;  
  margin: 10px auto;
  padding: 10px 0px;
  background-color: #f5f7f9;
}
.green { 
  color: #26b99a;
}
.red {
  color: #d9534f;
}
</style>



// WEBPACK FOOTER //
// src/components/transaction/transactionIcon.vue